const defaultGetAriaLabel = _ref => {
  let {
    type,
    page,
    selected
  } = _ref;
  if (type === 'page') {
    return `${selected ? '' : 'Go to '}page ${page}`;
  }
  return `Go to ${type} page`;
};

export { defaultGetAriaLabel };
